import * as React from 'react'
import { connect } from 'react-redux'
import { compose, pure } from 'recompose'

import PrepareParticipantStatus from '../../molecules/PrepareParticipantStatus/PrepareParticipantStatus'

import { CustomSpStore } from '../../../store'
import * as styles from './Prepare.css'

interface PrepareProps {
  participantCount?: number
  title: string
}

const Prepare: React.FunctionComponent<PrepareProps> = ({ participantCount, title }) => (
  <div className={styles.prepareParticipantStatus}>
    <PrepareParticipantStatus count={participantCount || 0} />
  </div>
)

const mapStateToProps = (state: CustomSpStore) => ({
  participantCount: state.questions.participantCount,
  title: state.questions.project.title
})

export default compose<PrepareProps, PrepareProps>(
  connect(mapStateToProps),
  pure
)(Prepare)
